export const backgroundColor = { backgroundColor: '#D9D9D9', padding: '1px' };
export const borderColor = { border: '1px solid #D9D9D9' };
export const pageHeader = { border: '1px solid #D9D9D9', padding: '12px' };
export const companySnapshotStyle = { background: '#ECECEC', padding: '0px' };
export const companySnapshotThinStyle = { background: '#ECECEC', padding: '4px', margin: '-16px' };
export const dashboardStyle = { background: '#ECECEC', padding: '4px', border: '1px solid #D9D9D9' };
export const tableBackgroundStyle = { padding: '0px', background: '#FFFFFF' };
export const darkTableBackgroundStyle = { background: '#ECECEC', padding: '30px' };